import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loading } from "../shared/constants/texts.js";

export const ArsenalHub = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const data = props.data;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <div>
      {/* Navigation */}
      <nav id="menu" className="navbar navbar-default navbar-fixed-top" style={{ background: 'rgba(255, 255, 255, 0.98)', borderBottom: '1px solid #e5e7eb' }}>
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ marginTop: '16px' }}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div  style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingTop: '12px', paddingBottom: '12px' }}>
              <div style={{ 
                width: '40px', 
                height: '40px', 
                background: '#f1f5f9', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
              }}>
                <i className={data?.Brand?.icon || "fa-solid fa-shield-halved"} style={{ color: '#475569', fontSize: '20px' }}></i>
              </div>
              <span style={{ color: '#111827', fontWeight: '700', fontSize: '20px' }}>{data?.Brand?.name || Loading}</span>
            </div>
          </div>

          <div className={`collapse navbar-collapse ${isMenuOpen ? 'in' : ''}`} id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav navbar-right">
              {data?.Navigation
                ? data.Navigation.map((item) => (
                    <li key={item.section}>
                      <a
                        href={`#${item.section}`}
                        onClick={() => scrollToSection(item.section)}
                        className="page-scroll"
                        style={{ cursor: 'pointer', color: '#4b5563', fontWeight: '500' }}
                      >
                        {item.label}
                      </a>
                    </li>
                  ))
                : null}
              <li>
                <Link to={data?.NavigationBackLink?.to || "/"} style={{ 
                  marginLeft: '10px',
                  padding: '8px 20px',
                  border: '2px solid #475569',
                  color: '#475569',
                  borderRadius: '6px',
                  fontWeight: '600',
                  transition: 'all 0.3s'
                }}>
                  {data?.NavigationBackLink?.label || Loading}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header id="inicio" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)',
        paddingTop: '100px',
        paddingBottom: '20px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div style={{ paddingTop: '40px' }}>
                <h1 style={{ fontSize: '48px', fontWeight: '700', lineHeight: '1.2', marginBottom: '24px', color: '#111827' }}>
                  {data?.Hero?.titleBefore || Loading}{" "}
                  <span style={{ color: '#475569' }}>{data?.Hero?.titleHighlight}</span>{" "}
                  {data?.Hero?.titleAfter}
                </h1>
                <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#4b5563', marginBottom: '32px' }}>
                  {data?.Hero?.paragraphBefore}{" "}
                  <strong>{data?.Hero?.paragraphHighlight}</strong>{" "}
                  {data?.Hero?.paragraphAfter}
                </p>

                {/* Benefits List */}
                <div className="row" style={{ marginBottom: '40px' }}>
                  {data?.Hero?.benefits
                    ? data.Hero.benefits.map((benefit, index) => (
                        <div key={index} className="col-sm-6" style={{ marginBottom: '12px' }}>
                          <i className="fa-solid fa-check-circle" style={{ color: '#475569', marginRight: '8px' }}></i>
                          <span style={{ color: '#4b5563' }}>{benefit}</span>
                        </div>
                      ))
                    : Loading}
                </div>

                {/* CTA Buttons */}
                {/* <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <button
                    onClick={() => scrollToSection('contato')}
                    className="btn btn-custom btn-lg"
                    style={{ background: '#475569', borderColor: '#475569', padding: '12px 32px', fontSize: '16px', fontWeight: '600' }}
                  >
                    Solicitar Demonstração <i className="fa-solid fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                  </button>
                  <Link
                    to="/#contact"
                    className="btn btn-lg"
                    style={{ 
                      border: '2px solid #475569', 
                      color: '#475569', 
                      background: 'transparent',
                      padding: '12px 32px', 
                      fontSize: '16px',
                      fontWeight: '600'
                    }}
                  >
                    <i className="fa-solid fa-play" style={{ marginRight: '8px' }}></i>
                    Conhecer Mais
                  </Link>
                </div> */}

                {/* Trust indicators */}
                <div style={{ display: 'flex', gap: '24px', marginTop: '40px', flexWrap: 'wrap', fontSize: '14px', color: '#6b7280' }}>
                  {data?.Hero?.trustIndicators
                    ? data.Hero.trustIndicators.map((indicator, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ width: '8px', height: '8px', background: '#475569', borderRadius: '50%' }}></div>
                          <span>{indicator}</span>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>

            {/* Dashboard Mockup */}
            <div className="col-md-6">
              <div style={{ position: 'relative', marginTop: '40px' }}>
                <div style={{
                  maxWidth: '500px',
                  margin: '0 auto',
                  background: '#fff',
                  padding: '20px',
                  borderRadius: '16px',
                  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
                    <div style={{ width: '12px', height: '12px', background: '#ef4444', borderRadius: '50%' }}></div>
                    <div style={{ width: '12px', height: '12px', background: '#f59e0b', borderRadius: '50%' }}></div>
                    <div style={{ width: '12px', height: '12px', background: '#10b981', borderRadius: '50%' }}></div>
                  </div>
                  <div style={{ height: '32px', background: '#e5e7eb', borderRadius: '6px', marginBottom: '16px' }}></div>
                  <div className="row">
                    <div className="col-xs-6">
                      <div style={{ 
                        background: '#f1f5f9', 
                        padding: '20px', 
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '32px', fontWeight: '700', color: '#475569' }}>{data?.Hero?.dashboard?.weaponsCount}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>{data?.Hero?.dashboard?.weaponsLabel}</div>
                      </div>
                    </div>
                    <div className="col-xs-6">
                      <div style={{ 
                        background: '#dbeafe', 
                        padding: '20px', 
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '32px', fontWeight: '700', color: '#2563eb' }}>{data?.Hero?.dashboard?.ammoCount}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>{data?.Hero?.dashboard?.ammoLabel}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ height: '96px', background: '#f3f4f6', borderRadius: '8px', marginTop: '16px' }}></div>
                </div>
                
                {/* Floating Icon */}
                <div style={{
                  position: 'absolute',
                  top: '-16px',
                  right: '-16px',
                  width: '80px',
                  height: '80px',
                  background: '#f1f5f9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'bounce 2s infinite'
                }}>
                  <i className="fa-solid fa-shield-halved" style={{ fontSize: '36px', color: '#475569' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Features Section */}
      <div id="funcionalidades" className="text-center" style={{ padding: '100px 0', background: '#f9fafb' }}>
        <div className="container">
          <div className="section-title">
            <h2>{data?.FeaturesSection?.title}{" "}<span style={{ color: '#475569' }}>{data?.FeaturesSection?.titleHighlight}</span></h2>
            <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '18px', lineHeight: '1.8' }}>
              {data?.FeaturesSection?.paragraph || Loading}
            </p>
          </div>
          <div className="row arsenalhub-features-row" style={{ marginTop: '60px' }}>
            {data?.MainFeatures
              ? data.MainFeatures.map((feature, index) => (
              <div key={index} className="col-md-6" style={{ marginBottom: '40px', display: 'flex' }}>
                <div className="arsenalhub-feature-card" style={{
                  background: '#fff',
                  padding: '40px',
                  borderRadius: '16px',
                  boxShadow: feature.highlight ? '0 10px 40px rgba(0,0,0,0.08)' : '0 4px 20px rgba(0,0,0,0.05)',
                  border: feature.highlight ? '2px solid #e2e8f0' : '1px solid #f1f5f9',
                  textAlign: 'left',
                  position: 'relative',
                  transition: 'all 0.3s',
                  height: '100%',
                  width: '100%'
                }}>
                  {feature.highlight && (
                    <div style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '32px',
                      background: '#475569',
                      color: '#fff',
                      padding: '4px 16px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {data?.FeaturesSection?.highlightLabel || "Destaque"}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '20px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      background: feature.highlight ? '#f1f5f9' : '#f9fafb',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <i className={`fa-solid ${feature.icon}`} style={{ 
                        fontSize: '24px', 
                        color: feature.highlight ? '#475569' : '#6b7280' 
                      }}></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '12px', color: '#111827' }}>
                        {feature.title}
                      </h3>
                      <p style={{ color: '#4b5563', marginBottom: '20px', lineHeight: '1.6' }}>
                        {feature.description}
                      </p>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {feature.features.map((item, idx) => (
                          <li key={idx} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="fa-solid fa-check-circle" style={{ color: '#475569', fontSize: '14px', flexShrink: 0 }}></i>
                            <span style={{ color: '#4b5563', fontSize: '14px' }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))
              : Loading}
          </div>

          {/* Additional Features */}
          <div className="row" style={{ marginTop: '40px' }}>
            {data?.AdditionalFeatures
              ? data.AdditionalFeatures.map((item, index) => (
                  <div key={index} className="col-md-4 col-sm-6" style={{ marginBottom: '24px' }}>
                    <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                      <i className={item.icon} style={{ fontSize: '40px', color: '#475569', marginBottom: '16px' }}></i>
                      <h4 style={{ fontWeight: '600', marginBottom: '8px' }}>{item.title}</h4>
                      <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>{item.description}</p>
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div id="beneficios" style={{ 
        background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', 
        padding: '100px 0',
        color: '#fff'
      }}>
        <div className="container">
          <div className="section-title text-center">
            <h2 style={{ color: '#fff' }}>{data?.BenefitsSection?.title || Loading}</h2>
            <p style={{ color: '#cbd5e1', maxWidth: '800px', margin: '0 auto', fontSize: '18px' }}>
              {data?.BenefitsSection?.paragraph}
            </p>
          </div>
          <div className="row text-center" style={{ marginTop: '60px' }}>
            {data?.BenefitsSection?.items
              ? data.BenefitsSection.items.map((item, index) => (
                  <div key={index} className="col-md-3 col-sm-6" style={{ marginBottom: '40px' }}>
                    <i className={item.icon} style={{ fontSize: '48px', marginBottom: '20px', color: '#cbd5e1' }}></i>
                    <h4 style={{ color: '#cbd5e1', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>{item.title}</h4>
                    <p style={{ color: '#cbd5e1', fontSize: '15px' }}>{item.description}</p>
                  </div>
                ))
              : Loading}
          </div>
        </div>
      </div>

      {/* Technologies Section */}
      {/* <div style={{ padding: '100px 0', background: '#fff' }}>
        <div className="container">
          <div className="section-title text-center">
            <h2>Tecnologias robustas</h2>
            <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '18px' }}>
              Desenvolvido com as melhores ferramentas do mercado para garantir performance e segurança
            </p>
          </div>
          <div className="row text-center" style={{ marginTop: '60px' }}>
            <div className="col-md-3 col-sm-6" style={{ marginBottom: '40px' }}>
              <i className="fa-brands fa-microsoft" style={{ fontSize: '64px', color: '#512BD4', marginBottom: '16px' }}></i>
              <h4 style={{ fontWeight: '600' }}>.NET</h4>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Backend robusto</p>
            </div>
            <div className="col-md-3 col-sm-6" style={{ marginBottom: '40px' }}>
              <i className="fa-solid fa-mobile-screen" style={{ fontSize: '64px', color: '#02569B', marginBottom: '16px' }}></i>
              <h4 style={{ fontWeight: '600' }}>Flutter</h4>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>App multiplataforma</p>
            </div>
            <div className="col-md-3 col-sm-6" style={{ marginBottom: '40px' }}>
              <i className="fa-solid fa-database" style={{ fontSize: '64px', color: '#336791', marginBottom: '16px' }}></i>
              <h4 style={{ fontWeight: '600' }}>PostgreSQL</h4>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Banco confiável</p>
            </div>
            <div className="col-md-3 col-sm-6" style={{ marginBottom: '40px' }}>
              <i className="fa-brands fa-docker" style={{ fontSize: '64px', color: '#2496ED', marginBottom: '16px' }}></i>
              <h4 style={{ fontWeight: '600' }}>Docker</h4>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Deploy containerizado</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Target Audience */}
      <div style={{ padding: '100px 0', background: '#f9fafb' }}>
        <div className="container">
          <div className="section-title text-center">
            <h2>{data?.TargetAudience?.title || Loading}</h2>
          </div>
          <div className="row" style={{ marginTop: '60px' }}>
            {data?.TargetAudience?.items
              ? data.TargetAudience.items.map((item, index) => (
                  <div key={index} className="col-md-4" style={{ marginBottom: '40px' }}>
                    <div style={{ 
                      background: '#fff', 
                      padding: '40px', 
                      borderRadius: '16px', 
                      textAlign: 'center',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                      height: '40%'
                    }}>
                      <i className={item.icon} style={{ fontSize: '48px', color: '#475569', marginBottom: '24px' }}></i>
                      <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>{item.title}</h4>
                      <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))
              : Loading}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      {/* <div id="contato" style={{ 
        background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', 
        padding: '100px 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{ color: '#fff', fontSize: '36px', fontWeight: '700', marginBottom: '24px' }}>
            Pronto para modernizar a gestão do seu acervo?
          </h2>
          <p style={{ color: '#cbd5e1', fontSize: '18px', maxWidth: '700px', margin: '0 auto 40px', lineHeight: '1.8' }}>
            Entre em contato conosco e descubra como o Arsenal Hub pode transformar a forma como você gerencia suas armas, munições e documentação legal.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/#contact"
              className="btn btn-custom btn-lg"
              style={{ background: '#fff', color: '#334155', borderColor: '#fff', padding: '12px 32px', fontSize: '18px', fontWeight: '600' }}
            >
              Fale com a gente <i className="fa-solid fa-arrow-right" style={{ marginLeft: '8px' }}></i>
            </Link>
            <a
              href="/arsenalhub/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-lg"
              style={{ 
                border: '2px solid #fff', 
                color: '#fff', 
                background: 'transparent',
                padding: '12px 32px', 
                fontSize: '18px',
                fontWeight: '600',
                textDecoration: 'none'
              }}
            >
              Política de Privacidade
            </a>
          </div>
        </div>
      </div> */}

      {/* Footer */}
      <div id="footer" style={{ background: '#1f2937', color: '#9ca3af', padding: '60px 0 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div style={{ marginBottom: '40px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    background: '#475569', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center' 
                  }}>
                    <i className={data?.Brand?.icon || "fa-solid fa-shield-halved"} style={{ color: '#fff', fontSize: '20px' }}></i>
                  </div>
                  <span style={{ color: '#fff', fontWeight: '700', fontSize: '20px' }}>{data?.Brand?.name || Loading}</span>
                </div>
                <p style={{ lineHeight: '1.8', marginBottom: '0' }}>
                  {data?.Footer?.description || Loading}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <h4 style={{ color: '#fff', fontWeight: '600', marginBottom: '24px' }}>{data?.Footer?.navigationTitle || "Navegação"}</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {data?.Navigation
                  ? data.Navigation.map((item) => (
                      <li key={item.section} style={{ marginBottom: '12px' }}>
                        <a
                          href={`#${item.section}`}
                          onClick={() => scrollToSection(item.section)}
                          style={{ color: '#9ca3af', cursor: 'pointer', transition: 'color 0.3s' }}
                        >
                          {item.label}
                        </a>
                      </li>
                    ))
                  : null}
              </ul>
            </div>
            <div className="col-md-4">
              <h4 style={{ color: '#fff', fontWeight: '600', marginBottom: '24px' }}>{data?.Footer?.quickAccessTitle || "Acesso Rápido"}</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {data?.Footer?.quickAccess
                  ? data.Footer.quickAccess.map((item, index) => (
                      <li key={index} style={{ marginBottom: '12px' }}>
                        {item.to ? (
                          <Link to={item.to} style={{ color: '#9ca3af', transition: 'color 0.3s' }}>
                            {item.label}
                          </Link>
                        ) : (
                          <a
                            href={item.href}
                            target={item.external ? "_blank" : undefined}
                            rel={item.external ? "noopener noreferrer" : undefined}
                            style={{ color: '#9ca3af', transition: 'color 0.3s', textDecoration: 'none' }}
                          >
                            {item.label}
                          </a>
                        )}
                      </li>
                    ))
                  : null}
              </ul>
            </div>
          </div>

          {/* <div style={{ 
            marginTop: '60px', 
            paddingTop: '30px', 
            borderTop: '1px solid #374151',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px'
          }}>
            <div style={{ display: 'flex', gap: '32px', fontSize: '14px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '8px', height: '8px', background: '#475569', borderRadius: '50%' }}></div>
                <span>Criptografia AES-256</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '8px', height: '8px', background: '#475569', borderRadius: '50%' }}></div>
                <span>LGPD Compliant</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '8px', height: '8px', background: '#475569', borderRadius: '50%' }}></div>
                <span>Dados Protegidos</span>
              </div>
            </div>
            <button
              onClick={scrollToTop}
              style={{
                padding: '10px 16px',
                background: '#475569',
                border: 'none',
                borderRadius: '8px',
                color: '#fff',
                cursor: 'pointer',
                transition: 'background 0.3s'
              }}
            >
              <i className="fa-solid fa-arrow-up"></i>
            </button>
          </div> */}

          <div style={{ 
            marginTop: '40px',
            paddingTop: '30px',
            paddingBottom: '30px',
            borderTop: '1px solid #374151',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', marginBottom: '8px' }}>
              © {new Date().getFullYear()} {data?.Footer?.copyright || Loading}
            </p>
            <p style={{ fontSize: '12px', marginBottom: '8px' }}>
              {data?.Footer?.disclaimer}
            </p>
            <p style={{ fontSize: '12px', margin: 0 }}>
              Desenvolvido por <strong style={{ color: '#cbd5e1' }}>{data?.Footer?.developer}</strong>
            </p>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        #funcionalidades .arsenalhub-features-row {
          display: flex;
          flex-wrap: wrap;
        }
      `}</style>
    </div>
  );
};
